import { storeCreator } from '@/utils/store/store.utils';


interface State {
  isModelChanged: boolean;
}
interface StateWithMethods extends State {
  setModelChanged: (value: boolean) => void;
}

const DEFAULT_VALUES: State = {
  isModelChanged: false,
};

export const useIsModelChangedStore = storeCreator<StateWithMethods>((set) => ({
  ...DEFAULT_VALUES,
  setModelChanged: (value:boolean) => set(() => ({
    isModelChanged: value
  })),
 
}));

export default useIsModelChangedStore;